module.exports = __webpack_public_path__ + "img/circle.93d68104.png";